import { giphyBlue, giphyGreen, giphyPurple, giphyYellow } from '@giphy/colors'

const userTypeColors: Record<string, string> = {
    creator: giphyPurple,
    partner: giphyBlue,
    artist: giphyGreen,
    user: giphyYellow,
}

export const getUserTypeColor = (userType?: string): string | undefined =>
    userType ? userTypeColors[userType.toLowerCase()] : undefined
